module.exports = __webpack_public_path__ + "img/f_06.41d1a1b.png";